import Phaser from 'phaser';

const NUM_ANIMS: readonly number[] = [5, 5, 5, 5, 5, 5, 4, 5, 5, 5];

// Registers idle animations puppyN.animK for every puppy and animation atlas.
// Frame names within an atlas are 'frame1.png', 'frame2.png', etc.
// Call once after all atlases have loaded.
export function registerPuppyAnimations(scene: Phaser.Scene): void {
  for (let i = 0; i < 10; i++) {
    const puppyNum = i + 1;
    for (let a = 1; a <= NUM_ANIMS[i]!; a++) {
      const atlasKey = `p${puppyNum}a${a}`;
      const animKey = `puppy${puppyNum}.anim${a}`;
      if (scene.anims.exists(animKey)) continue;
      const texture = scene.textures.get(atlasKey);
      if (!texture || texture.key === '__MISSING') continue;
      const names = texture
        .getFrameNames()
        .filter((n) => /^frame\d+(\.png)?$/.test(n))
        .sort((x, y) => {
          const nx = Number(x.match(/^frame(\d+)/)?.[1] ?? 0);
          const ny = Number(y.match(/^frame(\d+)/)?.[1] ?? 0);
          return nx - ny;
        });
      if (names.length === 0) continue;
      scene.anims.create({
        key: animKey,
        frames: names.map((name) => ({ key: atlasKey, frame: name })),
        // 10fps — slow enough to inspect individual frames in the debug
        // viewer; iOS uses 24fps but it's hard to spot offset/rotation
        // problems at that speed.
        frameRate: 10,
        repeat: -1,
      });
    }
  }
}

export function pickIdleAnimKey(puppyNum: number, randomInt: (n: number) => number): string {
  const anims = NUM_ANIMS[puppyNum - 1] ?? 1;
  const pick = randomInt(anims) + 1;
  return `puppy${puppyNum}.anim${pick}`;
}
